import * as Sentry from '@sentry/nextjs';

import getEnv from 'utils/getEnv';
import { isJsonResponse } from 'utils/isJsonResponse';

const CLOUD_FUNCTIONS_URL = getEnv('REACT_APP_CLOUD_FUNCTIONS_URL');

export const INVALID_EMAIL = 'Invalid Email';
export const ADD_EMAIL_ERROR = 'Unable to add email to list';

// check if response corresponds to invalid email
const isInvalidEmail = ({ status, msg, code }) =>
  status === 400 && code === 'BadParams' && msg === 'Invalid email';

// check if response corresponds to invalid listId
const isInvalidListId = ({ status, msg, code }) =>
  status === 400 && code === 'BadParams' && msg === 'Invalid email list id';

// Adds an email to an iterable list
export const addEmailToList = async (email, listId) => {
  const response = await fetch(new URL('/registerIterableEmail', CLOUD_FUNCTIONS_URL), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    referrerPolicy: 'unsafe-url',
    body: JSON.stringify({ email, listId }),
  });

  if (!response.ok) {
    const { status, statusText } = response;

    const responseData = { status, statusText };
    if (isJsonResponse(response)) {
      const responseBody = await response.json();
      Object.assign(responseData, responseBody);
    }

    if (isInvalidEmail(responseData)) {
      // invalid email is not reported to error service because it is only bad user input
      throw new Error(INVALID_EMAIL);
    }

    if (isInvalidListId(responseData)) {
      Sentry.withScope(scope => {
        scope.setExtra('responseData', responseData);
        Sentry.captureMessage('EmailListService: Invalid list ID');
      });
    } else {
      Sentry.withScope(scope => {
        scope.setExtra('responseData', responseData);
        Sentry.captureMessage('API Service (EmailListService.addEmailToList)');
      });
    }

    throw new Error(ADD_EMAIL_ERROR);
  }
};
